"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_merge_1 = __importDefault(require("lodash.merge"));
class PermissionResolver {
    constructor(config) {
        this.config = config;
        this.compiledConfig = this.compile();
    }
    compile() {
        let bitFields;
        const bitComputer = (parentBit) => {
            return 1 << parentBit;
        };
        const initResourceBitFields = (action, resource, bitfields) => {
            var _a;
            bitfields[action] = 0;
            const dependencies = (_a = resource[action]) !== null && _a !== void 0 ? _a : [];
            if (Array.isArray(dependencies) && dependencies.length > 0) {
                dependencies.map((dependency) => {
                    if (typeof bitfields[dependency] === 'undefined') {
                        bitfields[dependency] = initResourceBitFields(dependency, resource, bitfields);
                    }
                });
            }
            return 0;
        };
        const computeActionBitField = (action, resource, resourceBitFields, bitPosition) => {
            var _a;
            if (resourceBitFields[action] !== 0) {
                return resourceBitFields[action];
            }
            resourceBitFields[action] = bitComputer(bitPosition);
            const dependencies = (_a = resource[action]) !== null && _a !== void 0 ? _a : [];
            if (Array.isArray(dependencies) && dependencies.length > 0) {
                dependencies.map((dependency) => {
                    if (resourceBitFields[dependency] === 0) {
                        resourceBitFields[dependency] = computeActionBitField(dependency, resource, resourceBitFields, --bitPosition);
                    }
                    const dependencyBit = resourceBitFields[dependency];
                    const oldActionBit = resourceBitFields[action];
                    const newActionBit = oldActionBit | dependencyBit;
                    resourceBitFields[action] = newActionBit;
                });
            }
            return resourceBitFields[action];
        };
        Object.keys(this.config).map((namespace) => {
            Object.keys(this.config[namespace]).map((resourceName) => {
                const resource = this.config[namespace][resourceName];
                const resourceBitFields = {};
                Object.keys(resource).map((action) => {
                    initResourceBitFields(action, resource, resourceBitFields);
                });
                let nbBits = Object.keys(resourceBitFields).length;
                Object.keys(resourceBitFields).map((action) => {
                    computeActionBitField(action, resource, resourceBitFields, --nbBits);
                });
                bitFields = (0, lodash_merge_1.default)(bitFields, { [namespace]: { [resourceName]: resourceBitFields } });
            });
        });
        return bitFields;
    }
    resolveScopeBitField(scope) {
        var _a;
        const [namespace, resource, action] = scope.split('.');
        return (_a = this.compiledConfig[namespace][resource][action]) !== null && _a !== void 0 ? _a : 0;
    }
    verifiyScopePresentInConfig(scope) {
        const [namespace, resource, action] = scope.split('.');
        return (typeof this.config[namespace] !== 'undefined' &&
            typeof this.config[namespace][resource] !== 'undefined' &&
            typeof this.config[namespace][resource][action] !== 'undefined');
    }
    verifyScopeAuthorized(scopes, scopeToVerify) {
        var _a;
        let bitFieldScopes = {};
        if ((scopeToVerify !== null && scopeToVerify !== void 0 ? scopeToVerify : null) === null) {
            return false;
        }
        if (!scopeToVerify || !/^(?:\w+\.){2}\w+$/.test(scopeToVerify)) {
            return false;
        }
        if (!this.verifiyScopePresentInConfig(scopeToVerify)) {
            return false;
        }
        scopes.map((scope) => {
            var _a;
            let bitFieldScope = this.resolveScopeBitField(scope);
            const [namespaceScope, resourceScope] = scope.split('.');
            if (typeof ((_a = bitFieldScopes === null || bitFieldScopes === void 0 ? void 0 : bitFieldScopes[namespaceScope]) === null || _a === void 0 ? void 0 : _a[resourceScope]) !== 'undefined') {
                bitFieldScope |= bitFieldScopes[namespaceScope][resourceScope];
            }
            bitFieldScopes = (0, lodash_merge_1.default)(bitFieldScopes, { [namespaceScope]: { [resourceScope]: bitFieldScope } });
        });
        const bitFieldScopeToVerify = this.resolveScopeBitField(scopeToVerify);
        const [namespaceScopeToVerify, resourceScopeToVerify] = scopeToVerify.split('.');
        if (typeof ((_a = bitFieldScopes === null || bitFieldScopes === void 0 ? void 0 : bitFieldScopes[namespaceScopeToVerify]) === null || _a === void 0 ? void 0 : _a[resourceScopeToVerify]) !== 'undefined') {
            return ((bitFieldScopeToVerify & bitFieldScopes[namespaceScopeToVerify][resourceScopeToVerify]) >= bitFieldScopeToVerify);
        }
        return false;
    }
}
exports.default = PermissionResolver;
//# sourceMappingURL=permission-resolver.js.map